module.exports = __webpack_public_path__ + "static/Sedan-05295ebc93d1bcec1aec4d8defcac6cc.png";